<div>
  <div class="panel__header__button-container" style="display: flex; justify-content: end;">
             
    <a class="button waves-effect" style="margin-top: 10px;" (click)="onCloseClick()">
                    <i class="material-icons button__icon">cancel</i>
                    <span class="button__text">Close</span> 
                </a>
</div>

<table class="table">
  <thead>
    <tr>
      <th>Reading Number</th>
      <th>Evaluation</th>
      <th *ngIf="readings[0].ToolId == 7 || readings[0].ToolId == 10">Answer</th>
      <th *ngIf="readings[0].ToolId != 7 && readings[0].ToolId != 10">Measurement</th>
      <th>Est.</th>
      <th>Tool</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of readings" [ngSwitch]="r.ToolId">
      <td>{{r.Id}}</td>
      <td class="table__eval-cell"><span *ngIf="r.ToolId != Tool.YESorNO && r.ToolId != Tool.KeeperOrientation && r.ToolId != Tool.Eval" 
        class="Eval-{{ r.WornPercentage | wornPercentageToEval}}">{{r.WornPercentage.toFixed(1)}}%</span></td>
      <td *ngSwitchCase="Tool.YESorNO">
        <a  [matMenuTriggerFor]="yesNoMenu">{{getYesNo(r.Measurement)}}</a>
        <mat-menu #yesNoMenu="matMenu">
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 1)">Yes</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 0)">No</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, -1)">?</button>
        </mat-menu>
      </td>
      <td *ngSwitchCase="Tool.passFail">
        <a  [matMenuTriggerFor]="yesNoMenu">{{passFail(r.Measurement)}}</a>
        <mat-menu #yesNoMenu="matMenu">
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 1)">Pass</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 0)">Fail</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, -1)">?</button>
        </mat-menu>
      </td>
      <td *ngSwitchCase="Tool.KeeperOrientation">
        <a  [matMenuTriggerFor]="kpoMenu">{{getKPO(r.Measurement)}}</a>
        <mat-menu #kpoMenu="matMenu">
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 1)">A</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 2)">B</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 3)">C</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 4)">D</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, -1)">?</button>
        </mat-menu>
      </td>
      <td *ngSwitchCase="Tool.Eval">
        <a  [matMenuTriggerFor]="evalMenu">{{getEval(r.Measurement)}}</a>
        <mat-menu #evalMenu="matMenu">
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 1)">A</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 2)">B</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 3)">C</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, 4)">X</button>
          <button mat-menu-item (click)="updateMeasurementPointReading(r.Id, -1)">?</button>
        </mat-menu>
      </td>
      <td *ngSwitchDefault><div class="form-item"><div class="form-input"><edit-data inputId="reading{{r.Id}}" dataType="number" [canEdit]="true" [(value)]="r.Measurement" (valueChanged)="updateMeasurementPointReading(r.Id, $event)"></edit-data></div></div></td>
      <!-- <td>{{r.ToolId | toolIdToName}}</td> -->

      <td>
        <section class="example-section">
          <mat-slide-toggle class="example-margin"  [checked]="r.IsEstimate" 
          (change)="changetoggleEstimate(r)" >
          </mat-slide-toggle>
        </section>
      </td>
      <td> 
        <mat-select (selectionChange)="ToolSelected($event, r)" [(ngModel)]="r.ToolId" [value]="r.ToolId" name="toolval" style="min-width: 100px;">
        <mat-option *ngFor="let tool of PossibleToolList" [value]="tool.ToolId">
          {{tool.ToolName}}
        </mat-option>
      </mat-select>
    </td>
    </tr>
  </tbody>
</table>
</div>


